export const gradeMap = [
  {
    long: 'High School',
    short: 'HS',
  },
  {
    long: '8th',
    short: '8',
  },
  {
    long: '7th',
    short: '7',
  },
  {
    long: '6th',
    short: '6',
  },
  {
    long: '5th',
    short: '5',
  },
  {
    long: '4th',
    short: '4',
  },
  {
    long: '3rd',
    short: '3',
  },
  {
    long: '2nd',
    short: '2',
  },
  {
    long: '1st',
    short: '1',
  },
  {
    long: 'K',
    short: 'K',
  },
];

export enum CCSSType {
  GRADE = 'Grade',
  DOMAIN = 'Domain',
  CLUSTER = 'Cluster',
  STANDARD = 'Standard',
}
